// extracted by mini-css-extract-plugin
export default {"titleContainer":"NewsBoardTitle_titleContainer__SqKJl","titlePadding":"NewsBoardTitle_titlePadding__zkVDR"};